module.exports = __webpack_public_path__ + "static/media/97gal11.2c92e003.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/97gal/97gal11.jpg
// module id = 60
// module chunks = 0